var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#696969;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,6.2C14.6,6.2,6.2,14.6,6.2,25c0,8.3,5.4,15.3,12.8,17.8c0.9,0.2,1.3-0.4,1.3-0.9c0-0.4,0-1.6,0-3.2 c-5.2,1.1-6.3-2.5-6.3-2.5c-0.9-2.2-2.1-2.7-2.1-2.7c-1.7-1.2,0.1-1.1,0.1-1.1c1.9,0.1,2.9,1.9,2.9,1.9c1.7,2.9,4.4,2,5.5,1.6 c0.2-1.2,0.7-2,1.2-2.5C17.4,32.8,13,31.2,13,24c0-2.1,0.7-3.7,1.9-5c-0.2-0.5-0.8-2.4,0.2-5c0,0,1.6-0.5,5.2,1.9 c1.5-0.4,3.1-0.6,4.7-0.6c1.6,0,3.2,0.2,4.7,0.6c3.6-2.4,5.2-1.9,5.2-1.9c1,2.6,0.4,4.5,0.2,5c1.2,1.3,1.9,3,1.9,5 c0,7.2-4.4,8.8-8.6,9.3c0.7,0.6,1.3,1.7,1.3,3.5c0,2.5,0,4.5,0,5.1c0,0.5,0.3,1.1,1.3,0.9c7.4-2.5,12.8-9.5,12.8-17.8 C43.8,14.6,35.4,6.2,25,6.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.d956f0a22740ab6dd48d4a81c52de948.svg";
export { ForwardRef as ReactComponent };